import karteCustonEventClient from './karte/custom_event';

document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('header');
  if (header == null) {
    return;
  }

  const helpGuideButton = header.querySelector('.help-link') as HTMLElement;
  const supportButton = header.querySelector('.support-link') as HTMLElement;

  const sendKarteEvent = (event_name: string, content_name: string, message: string) => {
    // 更新したことをKARTEに通知
    karteCustonEventClient.sendEvent({
      event_name: event_name,
      content_name: content_name,
      message: message
    });
  }

  // クリック時に実行
  helpGuideButton.addEventListener('click', () => {
    // KARTEに登録イベントを送信
    sendKarteEvent(
      'click_button',
      'header_help_guide_button',
      'ヘッダーのヘルプガイドをクリックしました'
    );
  })

  supportButton.addEventListener('click', () => {
    // KARTEに登録イベントを送信
    sendKarteEvent(
      'click_button',
      'header_support_button',
      'ヘッダーのお問い合せをクリックしました'
    );
  })
});
